<mat-form-field appearance="outline">
    <mat-label>Personal Assistant Address</mat-label>
    <input #address matInput [formControl]="addressFormControl" [errorStateMatcher]="matcher">
    <mat-error *ngIf="addressFormControl.hasError('required')">
        Address is <strong>required</strong>
    </mat-error>
</mat-form-field>
